import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const MissionSection = () => {
  const values = [
    'Transparency in all operations',
    'Real, measurable impact',
    'Service above self',
    'Bringing families closer together',
  ];

  return (
    <section id="mission" className="py-24 bg-white" data-testid="mission-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#1E3A8A] mb-4">
              Our Mission
            </p>
            <h2 className="text-4xl sm:text-5xl font-medium text-[#0B1120] tracking-tight mb-6 leading-tight">
              Revolutionizing Philanthropy Through Purpose
            </h2>
            <p className="text-lg text-slate-600 font-light mb-8 leading-relaxed">
              At The Prestigious Travel Club Foundation, we believe generosity should be celebrated. 
              We are driven by a deep commitment to improving lives and creating a win-win 
              situation for donors and communities alike.
            </p>
            <p className="text-lg text-slate-600 font-light mb-8 leading-relaxed">
              By combining the joy of giving with meaningful impact, we fund critical initiatives 
              in education, healthcare, environmental sustainability, and veteran support—
              creating a positive ripple effect that transforms lives and empowers communities.
            </p>

            {/* Values */}
            <div className="space-y-4">
              {values.map((value, idx) => (
                <motion.div
                  key={idx}
                  className="flex items-center gap-3"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                >
                  <CheckCircle className="w-5 h-5 text-[#1E3A8A] flex-shrink-0" />
                  <span className="text-slate-700 font-medium">{value}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Image / Quote Card */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="premium-card">
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1761666507437-9fb5a6ef7b0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx2b2x1bnRlZXIlMjBoZWxwaW5nJTIwY29tbXVuaXR5fGVufDB8fHx8MTc3NDU3NzYwOHww&ixlib=rb-4.1.0&q=85"
                  alt="Volunteers helping community"
                  className="w-full h-64 object-cover rounded-xl mb-6"
                />
                <blockquote className="text-xl text-slate-700 font-serif italic leading-relaxed">
                  "The most selfish thing you can do in this world is help someone else, 
                  because the gratification, the goodness that comes to you—nothing is 
                  better than that."
                </blockquote>
                <div className="mt-6 flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-[#DBEAFE] flex items-center justify-center">
                    <span className="text-[#1E3A8A] font-serif text-xl">P</span>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800">Prestigious Travel Club</p>
                    <p className="text-sm text-slate-500">Foundation Philosophy</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -z-10 top-8 -right-8 w-full h-full border-2 border-[#1E3A8A]/20 rounded-2xl" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
